import React from 'react';
import './RestaurantManagement.scss';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { GeneralRestaurantData } from './GeneralRestaurantData/GeneralRestaurantData';
import { Tables } from './Tables/Tables';
import { Menus } from './Menus/Menus';
import { Table } from './Tables/Table/Table';

export const RestaurantManagement = (): JSX.Element => {
	return (
		<div className="restaurantManagementContainer">
			<div className="manageRestaurantMenuContainer">
				<NavLink to="general" className={({ isActive }): string => `manageRestaurantButton ${isActive ? 'active' : ''}`}>
					מידע כללי
				</NavLink>
				<NavLink to="tables" className={({ isActive }): string => `manageRestaurantButton ${isActive ? 'active' : ''}`}>
					שולחנות
				</NavLink>
				<NavLink to="menus" className={({ isActive }): string => `manageRestaurantButton ${isActive ? 'active' : ''}`}>
					תפריטים
				</NavLink>
			</div>
			<Routes>
				<Route index element={<Navigate to="general" replace />} />
				<Route path="general" element={<GeneralRestaurantData />} />
				<Route path="tables" element={<Tables />} />
				<Route path="table" element={<Table />} />
				<Route path="table/:id" element={<Table />} />
				<Route path="menus" element={<Menus />} />
				<Route path="*" element={<div>Not found inside menu</div>} />
			</Routes>
		</div>
	);
};
